import React from "react";
import "./about.css";
import ArchiveImg from "./images/archive.jpg";
import AnalysisImg from "./images/analysis.jpg";
function About() {
  const Topic = [
    "PHYSICS",
    "Electrostatics",
    "Capacitors",
    "Simple Harmonic Motion",
    "Sound Waves",
    "Elasticity",
    "Circular Motion",
    "Electromagnetic Waves",
    "Semiconductors",
    "Magnetic Effect of Current and Magnetism",
    "Alternating Current",
    "Kinetic Theory of Gases & Thermodynamics",
    "Kinematics",
    "Work Energy Power",
    "Laws of Motion",
    "Centre Of Mass",
    "Rotational Dynamics",
    "Wave Optics",
    "Current Electricity",
    "ElectroMagnetic Induction",
    "CHEMISTRY",
    "Mole Concept",
    "Redox Reactions",
    "Electrochemistry ",
    "Chemical Kinetics ",
    "Solution ",
    "General Organic Chemistry ",
    "Stereochemistry ",
    "Hydrocarbon ",
    "Alkyl Halides ",
    "Carboxylic Acids & their Derivatives",
    "Carbohydrates, Amino-Acids, and Polymers ",
    "Aromatic Compounds ",
    "Atomic Structure",
    "Chemical Bonding",
    "Chemical And Ionic Equilibrium",
    "Solid-State And Surface Chemistry",
    "Thermodynamics & the Gaseous State",
    "Transition Elements & Coordination Compounds",
    "Periodic table, s and p-Block Elements ",
    "MATHS",
    "Sets",
    "Permutations & Combinations",
    "Probability",
    "Complex Numbers",
    "Binominal Theorem",
    "Limits",
    "Differentiability",
    "Indefinite Integration",
    "Definite Integration",
    "Differential Equations",
    "Height & Distance",
    "Trigonometric Equations",
    "Quadratic Equations ",
    "Vectors",
    "Tangents and Normals",
    "Maxima and Minima",
    "Statistics",
    "Parabola",
    "Ellipse",
    "Hyperbola",
    "Straight Lines",
    "Sequences & Series",
    "Matrix And Determinants",
  ];
  const Topics = () => {
    return <div className="d-flex flex-wrap justify-content-center">{Topic.map(Card)}</div>;
  };
  const Card = (topic) => {
    return <div className="card">
        <h6 className = "text-center" style = {{color : "whitesmoke", margin : "auto"}}>{topic}</h6>
    </div>;
  };
  const AboutTop = () => {
    return (
      <div className="aboutTop">
        <div className="archiveImg">
          <img src={ArchiveImg} alt="Archive Image" />
        </div>
        <div className="aboutTopText">
          <h3 className="text-center">Archive</h3>
          <p className="text-center" >
            An archive of previous year JEE questions.
          </p>
        </div>
      </div>
    );
  };

  const Analysis = () =>{
    return (
      <div className="about-analysis">
        <div className="analysisText">
          <h3 className="text-center">Analysis</h3>
          <p className="text-center p-5">
            Detailed analysis of your performance on each question.
          </p>
        </div>
        <div className="analysisImg">
          <img src={AnalysisImg} alt="Analysis Demo Image" />
        </div>
      </div>
    );
  };

  return (
    <div className="about-page">
      <AboutTop />
      <div className="topics py-5">
          <h3 className = "text-center" style = {{color : "white"}} >Topics To be Covered</h3>
        <Topics />
      </div>
      <div className="analysisDiv">
        <Analysis />  
      </div>  
    
    </div>
  );
}
export default About;
